import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Typography } from '@mui/material';
import { OverflowTooltip } from '../tooltips/overflowTooltip';
export const ChangeableTextField = t0 => {
  const $ = _c(14);
  const {
    value,
    noValueButtonText: t1,
    hasValueButtonText: t2,
    onClick,
    placeholder,
    disabled: t3
  } = t0;
  const noValueButtonText = t1 === undefined ? "Select" : t1;
  const hasValueButtonText = t2 === undefined ? "Change" : t2;
  const disabled = t3 === undefined ? false : t3;
  const t4 = disabled ? undefined : onClick;
  const t5 = disabled ? "default" : "pointer";
  let t6;
  if ($[0] !== t5) {
    t6 = {
      gap: "12px",
      alignItems: "center",
      justifyContent: "space-between",
      paddingLeft: "20px",
      paddingRight: "12px",
      height: "48px",
      border: "1px solid var(--mui-palette-divider)",
      borderRadius: "var(--mui-shape-customBorderRadius-sm)",
      cursor: t5
    };
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== placeholder || $[3] !== value) {
    t7 = value ? <OverflowTooltip text={value} /> : <Typography sx={{
      color: "text.disabled"
    }}>{placeholder}</Typography>;
    $[2] = placeholder;
    $[3] = value;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = value ? "text" : "contained";
  const t9 = value ? hasValueButtonText : noValueButtonText;
  let t10;
  if ($[5] !== disabled || $[6] !== t8 || $[7] !== t9) {
    t10 = <Button disabled={disabled} variant={t8}>{t9}</Button>;
    $[5] = disabled;
    $[6] = t8;
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== t10 || $[10] !== t4 || $[11] !== t6 || $[12] !== t7) {
    t11 = <Stack direction="row" onClick={t4} sx={t6}>{t7}{t10}</Stack>;
    $[9] = t10;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
};